// extracted by mini-css-extract-plugin
export var contentBody = "_3r-9";
export var headerImage = "_3r-2";
export var imageButton = "_3r-7";
export var imageButtonIcon = "_3r-8";
export var imageHeader = "_3r-4";
export var imageHeaderText = "_3r-5";
export var imageOverlay = "_3r-3";
export var imageTitle = "_3r-6";
export var imageWrapper = "_3r-1";
export var taskList = "_3r-a";
export var widget = "_3r-0";